/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import CancelAction from './CancelAction/index'
import CloseAction from './CloseAction/index'
import Main from './Main/index'
import ModalFullScreen from 'DesignSystem/ModalFullScreen/index'
import React from 'react'
import TysiaHeading from 'DesignSystem/TysiaHeading/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/DesignSystem/TimelineEvent/Appointment/Actions/Scheduled/More/AppointmentHistory/Content"
  
}) {
let dtSpaceM = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.m'
        })
let dtColorsWhite = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.white'
        })
  return (<React.Fragment
>
<ModalFullScreen
  viewPath={`${viewPath}/ModalFullScreen`}
 height="auto"
 dangerouslyBypassFocusLock={true}
>
{childProps => (
<React.Fragment>
<div
  data-testid="Content.Vertical"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical}`}
>
<div
  data-testid="Content.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaHeading
  viewPath={`${viewPath}/TysiaHeading`}
 marginTop={0}
 level="h2"
 text="Appointment history"
/>
<CloseAction
  viewPath={`${viewPath}/CloseAction`}
/>
</div>
</div>
<div
  data-testid="Content.Vertical:1"
  data-view-path={viewPath}
 style={{'--mt-1-Z1Yf8zk': typeof dtSpaceM === 'number' ? `${dtSpaceM}px` : dtSpaceM,'--mb-2-Z1Yf8zk': typeof dtSpaceM === 'number' ? `${dtSpaceM}px` : dtSpaceM}}
 className={`views-block ${styles.Vertical1}`}
>
<Main
  viewPath={`${viewPath}/Main`}
/>
</div>
<div
  data-testid="Content.Horizontal:1"
  data-view-path={viewPath}
 style={{'--bc-3-Z1Yf8zk': dtColorsWhite}}
 className={`views-block ${styles.Horizontal1}`}
>
<CancelAction
  viewPath={`${viewPath}/CancelAction`}
/>
</div>
</React.Fragment>
)}
</ModalFullScreen>
{children}
</React.Fragment>)
}